import * as ambassadorWixBillingV1ManualTaxMapping from './billing-v1-manual-tax-mapping-manual-tax-mappings.http.js';
import * as ambassadorWixBillingV1ManualTaxMappingTypes from './billing-v1-manual-tax-mapping-manual-tax-mappings.types.js';
import * as ambassadorWixBillingV1ManualTaxMappingUniversalTypes from './billing-v1-manual-tax-mapping-manual-tax-mappings.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function createManualTaxMapping(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixBillingV1ManualTaxMappingUniversalTypes.CreateManualTaxMappingRequest,
  ambassadorWixBillingV1ManualTaxMappingTypes.CreateManualTaxMappingRequest,
  ambassadorWixBillingV1ManualTaxMappingUniversalTypes.CreateManualTaxMappingResponse,
  ambassadorWixBillingV1ManualTaxMappingTypes.CreateManualTaxMappingResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixBillingV1ManualTaxMapping.createManualTaxMapping(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/manual-tax-mappings',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkCreateManualTaxMappings(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixBillingV1ManualTaxMappingUniversalTypes.BulkCreateManualTaxMappingsRequest,
  ambassadorWixBillingV1ManualTaxMappingTypes.BulkCreateManualTaxMappingsRequest,
  ambassadorWixBillingV1ManualTaxMappingUniversalTypes.BulkCreateManualTaxMappingsResponse,
  ambassadorWixBillingV1ManualTaxMappingTypes.BulkCreateManualTaxMappingsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixBillingV1ManualTaxMapping.bulkCreateManualTaxMappings(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/bulk/manual-tax-mappings/create',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getManualTaxMapping(): __PublicMethodMetaInfo<
  'GET',
  { manualTaxMappingId: string },
  ambassadorWixBillingV1ManualTaxMappingUniversalTypes.GetManualTaxMappingRequest,
  ambassadorWixBillingV1ManualTaxMappingTypes.GetManualTaxMappingRequest,
  ambassadorWixBillingV1ManualTaxMappingUniversalTypes.GetManualTaxMappingResponse,
  ambassadorWixBillingV1ManualTaxMappingTypes.GetManualTaxMappingResponse
> {
  const payload = { manualTaxMappingId: ':manualTaxMappingId' } as any;

  const getRequestOptions =
    ambassadorWixBillingV1ManualTaxMapping.getManualTaxMapping(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/manual-tax-mappings/{manualTaxMappingId}',
    pathParams: { manualTaxMappingId: 'manualTaxMappingId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function updateManualTaxMapping(): __PublicMethodMetaInfo<
  'PATCH',
  { manualTaxMappingId: string },
  ambassadorWixBillingV1ManualTaxMappingUniversalTypes.UpdateManualTaxMappingRequest,
  ambassadorWixBillingV1ManualTaxMappingTypes.UpdateManualTaxMappingRequest,
  ambassadorWixBillingV1ManualTaxMappingUniversalTypes.UpdateManualTaxMappingResponse,
  ambassadorWixBillingV1ManualTaxMappingTypes.UpdateManualTaxMappingResponse
> {
  const payload = { manualTaxMapping: { id: ':manualTaxMappingId' } } as any;

  const getRequestOptions =
    ambassadorWixBillingV1ManualTaxMapping.updateManualTaxMapping(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'PATCH',
    path: '/v1/manual-tax-mappings/{manualTaxMapping.id}',
    pathParams: { manualTaxMappingId: 'manualTaxMappingId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function deleteManualTaxMapping(): __PublicMethodMetaInfo<
  'DELETE',
  { manualTaxMappingId: string },
  ambassadorWixBillingV1ManualTaxMappingUniversalTypes.DeleteManualTaxMappingRequest,
  ambassadorWixBillingV1ManualTaxMappingTypes.DeleteManualTaxMappingRequest,
  ambassadorWixBillingV1ManualTaxMappingUniversalTypes.DeleteManualTaxMappingResponse,
  ambassadorWixBillingV1ManualTaxMappingTypes.DeleteManualTaxMappingResponse
> {
  const payload = { manualTaxMappingId: ':manualTaxMappingId' } as any;

  const getRequestOptions =
    ambassadorWixBillingV1ManualTaxMapping.deleteManualTaxMapping(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'DELETE',
    path: '/v1/manual-tax-mappings/{manualTaxMappingId}',
    pathParams: { manualTaxMappingId: 'manualTaxMappingId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function queryManualTaxMappings(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixBillingV1ManualTaxMappingUniversalTypes.QueryManualTaxMappingsRequest,
  ambassadorWixBillingV1ManualTaxMappingTypes.QueryManualTaxMappingsRequest,
  ambassadorWixBillingV1ManualTaxMappingUniversalTypes.QueryManualTaxMappingsResponse,
  ambassadorWixBillingV1ManualTaxMappingTypes.QueryManualTaxMappingsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixBillingV1ManualTaxMapping.queryManualTaxMappings(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/manual-tax-mappings/query',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function updateExtendedFields(): __PublicMethodMetaInfo<
  'POST',
  { id: string },
  ambassadorWixBillingV1ManualTaxMappingUniversalTypes.UpdateExtendedFieldsRequest,
  ambassadorWixBillingV1ManualTaxMappingTypes.UpdateExtendedFieldsRequest,
  ambassadorWixBillingV1ManualTaxMappingUniversalTypes.UpdateExtendedFieldsResponse,
  ambassadorWixBillingV1ManualTaxMappingTypes.UpdateExtendedFieldsResponse
> {
  const payload = { id: ':id' } as any;

  const getRequestOptions =
    ambassadorWixBillingV1ManualTaxMapping.updateExtendedFields(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/manual-tax-mappings/{id}/update-extended-fields',
    pathParams: { id: 'id' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkAssignExemptOverrides(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixBillingV1ManualTaxMappingUniversalTypes.BulkAssignExemptOverridesRequest,
  ambassadorWixBillingV1ManualTaxMappingTypes.BulkAssignExemptOverridesRequest,
  ambassadorWixBillingV1ManualTaxMappingUniversalTypes.BulkAssignExemptOverridesResponse,
  ambassadorWixBillingV1ManualTaxMappingTypes.BulkAssignExemptOverridesResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixBillingV1ManualTaxMapping.bulkAssignExemptOverrides(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/manual-tax-mappings/bulk-assign-exempt-overrides',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkUnassignExemptOverrides(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixBillingV1ManualTaxMappingUniversalTypes.BulkUnassignExemptOverridesRequest,
  ambassadorWixBillingV1ManualTaxMappingTypes.BulkUnassignExemptOverridesRequest,
  ambassadorWixBillingV1ManualTaxMappingUniversalTypes.BulkUnassignExemptOverridesResponse,
  ambassadorWixBillingV1ManualTaxMappingTypes.BulkUnassignExemptOverridesResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixBillingV1ManualTaxMapping.bulkUnassignExemptOverrides(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/manual-tax-mappings/bulk-unassign-exempt-overrides',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function listManualTaxMappings(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixBillingV1ManualTaxMappingUniversalTypes.ListManualTaxMappingsRequest,
  ambassadorWixBillingV1ManualTaxMappingTypes.ListManualTaxMappingsRequest,
  ambassadorWixBillingV1ManualTaxMappingUniversalTypes.ListManualTaxMappingsResponse,
  ambassadorWixBillingV1ManualTaxMappingTypes.ListManualTaxMappingsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixBillingV1ManualTaxMapping.listManualTaxMappings(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/manual-tax-mappings',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  ManualTaxMapping as ManualTaxMappingOriginal,
  JurisdictionType as JurisdictionTypeOriginal,
  JurisdictionTypeWithLiterals as JurisdictionTypeWithLiteralsOriginal,
  ExemptDetails as ExemptDetailsOriginal,
  ExtendedFields as ExtendedFieldsOriginal,
  CreateManualTaxMappingRequest as CreateManualTaxMappingRequestOriginal,
  CreateManualTaxMappingResponse as CreateManualTaxMappingResponseOriginal,
  BulkCreateManualTaxMappingsRequest as BulkCreateManualTaxMappingsRequestOriginal,
  BulkCreateManualTaxMappingsResponse as BulkCreateManualTaxMappingsResponseOriginal,
  ItemMetadata as ItemMetadataOriginal,
  ApplicationError as ApplicationErrorOriginal,
  BulkManualTaxMappingResult as BulkManualTaxMappingResultOriginal,
  BulkActionMetadata as BulkActionMetadataOriginal,
  GetManualTaxMappingRequest as GetManualTaxMappingRequestOriginal,
  GetManualTaxMappingResponse as GetManualTaxMappingResponseOriginal,
  UpdateManualTaxMappingRequest as UpdateManualTaxMappingRequestOriginal,
  UpdateManualTaxMappingResponse as UpdateManualTaxMappingResponseOriginal,
  DeleteManualTaxMappingRequest as DeleteManualTaxMappingRequestOriginal,
  DeleteManualTaxMappingResponse as DeleteManualTaxMappingResponseOriginal,
  QueryManualTaxMappingsRequest as QueryManualTaxMappingsRequestOriginal,
  CursorQuery as CursorQueryOriginal,
  CursorQueryPagingMethodOneOf as CursorQueryPagingMethodOneOfOriginal,
  Sorting as SortingOriginal,
  SortOrder as SortOrderOriginal,
  SortOrderWithLiterals as SortOrderWithLiteralsOriginal,
  CursorPaging as CursorPagingOriginal,
  QueryManualTaxMappingsResponse as QueryManualTaxMappingsResponseOriginal,
  CursorPagingMetadata as CursorPagingMetadataOriginal,
  Cursors as CursorsOriginal,
  UpdateExtendedFieldsRequest as UpdateExtendedFieldsRequestOriginal,
  UpdateExtendedFieldsResponse as UpdateExtendedFieldsResponseOriginal,
  BulkRestoreManualTaxMappingsRequest as BulkRestoreManualTaxMappingsRequestOriginal,
  BulkRestoreManualTaxMappingsResponse as BulkRestoreManualTaxMappingsResponseOriginal,
  BulkRestoreManualTaxMappingsResult as BulkRestoreManualTaxMappingsResultOriginal,
  BulkAssignExemptOverridesRequest as BulkAssignExemptOverridesRequestOriginal,
  AssignOverride as AssignOverrideOriginal,
  ExemptGroupIdOverride as ExemptGroupIdOverrideOriginal,
  BulkAssignExemptOverridesResponse as BulkAssignExemptOverridesResponseOriginal,
  BulkExemptOverrideResult as BulkExemptOverrideResultOriginal,
  BulkUnassignExemptOverridesRequest as BulkUnassignExemptOverridesRequestOriginal,
  UnassignOverride as UnassignOverrideOriginal,
  BulkUnassignExemptOverridesResponse as BulkUnassignExemptOverridesResponseOriginal,
  ListManualTaxMappingsRequest as ListManualTaxMappingsRequestOriginal,
  ListManualTaxMappingsResponse as ListManualTaxMappingsResponseOriginal,
  DomainEvent as DomainEventOriginal,
  DomainEventBodyOneOf as DomainEventBodyOneOfOriginal,
  EntityCreatedEvent as EntityCreatedEventOriginal,
  RestoreInfo as RestoreInfoOriginal,
  EntityUpdatedEvent as EntityUpdatedEventOriginal,
  EntityDeletedEvent as EntityDeletedEventOriginal,
  ActionEvent as ActionEventOriginal,
  Empty as EmptyOriginal,
  MessageEnvelope as MessageEnvelopeOriginal,
  IdentificationData as IdentificationDataOriginal,
  IdentificationDataIdOneOf as IdentificationDataIdOneOfOriginal,
  WebhookIdentityType as WebhookIdentityTypeOriginal,
  WebhookIdentityTypeWithLiterals as WebhookIdentityTypeWithLiteralsOriginal,
  AccountInfo as AccountInfoOriginal,
  CreateManualTaxMappingApplicationErrors as CreateManualTaxMappingApplicationErrorsOriginal,
  UpdateManualTaxMappingApplicationErrors as UpdateManualTaxMappingApplicationErrorsOriginal,
} from './billing-v1-manual-tax-mapping-manual-tax-mappings.types.js';
